import { createReducer } from "@ec-oem/ec.oem.oa3.ui.core/utility";
import {
	ADD_MESSAGES,
	SET_LIST,
	SET_COUNT,
	SET_CONVERSATION_ID,
	SET_ABORT_CONTROLLER,
	SET_CONVERSATION_ALLOWED,
	SET_IS_RESPONSE_STOP_ENABLED,
	SET_KEY_CATEGORIES_LIST,
	SET_SHOW_STREAMING_PLACEHOLDER,
	SET_STREAMING_CONTENT,
	SET_COSMIC_TICKETS, 
	SET_COSMIC_TICKETS_LOADING, 
	SET_COSMIC_TICKETS_ERROR, 
	SET_COSMIC_CASE_ACTION_RESULT, // AI
	SET_COSMIC_CASE_ACTION_LOADING // AI
} from "./ChatBot.actions";
import { fromJS } from "immutable";

export const conversationlist = createReducer(null, {
	[ADD_MESSAGES](state, { conversationlist }) {
		return conversationlist ? conversationlist : null;
	}
});

export const messageitemlist = createReducer(null, {
	[SET_LIST](state, { messageitemlist }) {
		return fromJS(messageitemlist);
	}
});

export const keyCategoriesList = createReducer(null, {
	[SET_KEY_CATEGORIES_LIST](state, { keyCategoriesList }) {
		return fromJS(keyCategoriesList);
	}
});

export const count = createReducer(null, {
	[SET_COUNT](state, { count }) {
		return count ? count : null;
	}
});

export const conversationid = createReducer(null, {
	[SET_CONVERSATION_ID](state, { conversationid }) {
		return conversationid ? conversationid : null;
	}
});

export const abortController = createReducer(null, {
	[SET_ABORT_CONTROLLER](state, { abortController }) {
		return fromJS(abortController);
	}
});

export const conversationAllowed = createReducer(null, {
	[SET_CONVERSATION_ALLOWED](state, { conversationAllowed }) {
		return conversationAllowed;
	}
});

export const isResponseStopEnabled = createReducer(null, {
	[SET_IS_RESPONSE_STOP_ENABLED](state, { isResponseStopEnabled }) {
		return isResponseStopEnabled;
	}
});

export const showStreamingPlaceholder = createReducer(null, {
	[SET_SHOW_STREAMING_PLACEHOLDER](state, { showStreamingPlaceholder }) {
		return showStreamingPlaceholder;
	}
});

export const streamingContent = createReducer(null, {
	[SET_STREAMING_CONTENT](state, { streamingContent }) {
		return streamingContent;
	}
});

export const cosmicTickets = createReducer(null, { 
	[SET_COSMIC_TICKETS](state, { cosmicTickets }) { 
		return cosmicTickets ? fromJS(cosmicTickets) : null; 
	} 
}); 

export const cosmicTicketsLoading = createReducer(false, { 
	[SET_COSMIC_TICKETS_LOADING](state, { cosmicTicketsLoading }) { 
		return !!cosmicTicketsLoading; 
	} 
}); 

export const cosmicTicketsError = createReducer(null, { 
	[SET_COSMIC_TICKETS_ERROR](state, { cosmicTicketsError }) { 
		return cosmicTicketsError ? cosmicTicketsError : null; 
	} 
}); 

export const cosmicCaseActionResult = createReducer(null, { // AI: holds inline success/error state for resolve/reactivate shown within CaseDetail
	[SET_COSMIC_CASE_ACTION_RESULT](state, { cosmicCaseActionResult }) { // AI
		return cosmicCaseActionResult ? cosmicCaseActionResult : null; // AI
	} // AI
}); // AI

export const cosmicCaseActionLoading = createReducer(false, { // AI: tracks in-flight resolve/reactivate request
	[SET_COSMIC_CASE_ACTION_LOADING](state, { cosmicCaseActionLoading }) { // AI
		return !!cosmicCaseActionLoading; // AI
	} // AI
}); // AI